module.exports = __webpack_public_path__ + "img/form-settings-option-link.523f4fab.svg";